// extracted by mini-css-extract-plugin
export default {"mainBody":"Home_mainBody__GasWb"};